import styled from "styled-components";
import { device } from "../../constants";

export const FooterContainer = styled.footer`
  background-color: #1d202a;
  padding: 40px 20px;

  @media ${device.tablet} {
    padding: 40px 40px;
  }

  @media ${device.laptop} {
    padding: 80px;
  }
`;

export const FooterContent = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  @media ${device.tablet} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 40px;
  }

  @media ${device.laptop} {
    flex-wrap: nowrap;
    gap: 40px;
  }

  @media ${device.laptopM} {
    gap: 80px;
  }
`;

export const LogoWrapper = styled.div`
  flex-shrink: 0;

  .mobile-logo {
    display: block;
    width: 190px;
    height: 48px;
  }

  .desktop-logo {
    display: none;
  }

  @media ${device.tablet} {
    width: 140px;

    .mobile-logo {
      display: none;
    }

    .desktop-logo {
      display: block;
      width: 140px;
      height: auto;
    }
  }
`;

export const LinksSection = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
  flex-shrink: 0;
  white-space: nowrap;

  @media ${device.tablet} {
    align-items: flex-start;
    gap: 20px;
  }

  @media ${device.laptop} {
    align-items: flex-start;
    height: 132px;
  }
`;

export const FooterLink = styled.a`
  color: white;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 1.2px;

  @media ${device.tablet} {
    font-size: 14px;
    line-height: 24px;
  }
  text-transform: uppercase;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
  cursor: pointer;
  height: 16px;
  display: flex;
  align-items: center;
  overflow: hidden;

  &:hover {
    opacity: 0.8;
  }
`;

export const AddressSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  color: white;
  text-align: center;

  @media ${device.tablet} {
    align-items: flex-start;
    text-align: left;
    gap: 16px;
  }

  @media ${device.laptop} {
    align-items: flex-start;
    height: 140px;
  }
`;

export const AddressTitle = styled.p`
  margin: 0;
  color: white;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 1.2px;
  text-transform: uppercase;

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 32px;
  }
`;

export const AddressLines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AddressLine = styled.p`
  margin: 0;
  color: white;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0;

  @media ${device.tablet} {
    font-size: 18px;
  }
`;

export const NewsletterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex: 1;
  min-width: 0;
  position: relative;

  @media ${device.tablet} {
    align-items: flex-start;
    flex-direction: row;
    flex-basis: 100%;
    gap: 24px;
    align-items: flex-end;
  }

  @media ${device.laptop} {
    flex-direction: column;
    align-items: flex-start;
    flex-basis: auto;
    height: 140px;
  }
`;

export const NewsletterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const NewsletterTitle = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  color: white;
  text-align: center;
  width: 100%;

  @media ${device.tablet} {
    font-size: 18px;
    font-weight: 600;
    text-align: left;
  }
`;

export const NewsletterInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const NewsletterInput = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid white;
  border-radius: 8px;
  padding: 0 48px 0 16px;
  background: transparent;
  color: white;
  font-size: 14px;
  line-height: 28px;

  @media ${device.tablet} {
    font-size: 18px;
  }

  &::placeholder {
    color: white;
  }

  &:focus {
    outline: none;
  }
`;

export const NewsletterButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 40px;
  background: white;
  border: none;
  border-radius: 0 8px 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 12px;

  &:hover {
    opacity: 0.9;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;

export const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;

  svg {
    width: 32px;
    height: 32px;
  }

  @media ${device.tablet} {
    svg {
      width: 40px;
      height: 40px;
    }
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const CopyrightBar = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #15191e;
  border-top: 1px solid #7b7b7b;
  color: #c0c0c0;
  font-size: 12px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 20px;
  }
`;
